export enum gridBreakpointsEnum {
  sm = 767,
  md = 991,
  lg = 1199,
  mediumDevicesUp = 768,
}
